module.exports = __webpack_public_path__ + "img/send_02.04216d1e.png";